var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page_header"},[(_vm.hasBack)?_c('img',{staticClass:"back",attrs:{"src":"/static/images/user/back.png"},on:{"click":_vm.back}}):_vm._e(),_vm._v(" "),_c('img',{staticClass:"logo",attrs:{"src":"/static/images/user/logo.png"}}),_vm._v(" "),_c('span',{staticClass:"name"},[_vm._v("陆家嘴白领艺术中心")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-feda6eb8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header.vue
// module id = null
// module chunks = 